import ApplicationTypeListModel from './screens/applicationtypelistmodel-list-screen.vue';
import CanonicalCodeListModel from './screens/canonicalcodelistmodel-list-screen.vue';
import CarrierApplicationViewModel from './screens/custom/carrierapplicationviewmodel-custom-screen.vue';
import ChargeBeeInvoicesApplicationViewModel from './screens/custom/chargebeeinvoicesapplicationviewmodel-custom-screen.vue';
import CrossReferenceApplicationViewModel from './screens/custom/crossreferenceapplicationviewmodel-custom-screen.vue';
import CustomerApplicationListModel from './screens/customerapplicationlistmodel-list-screen.vue';
import CustomerListModel from './screens/customerlistmodel-list-screen.vue';
import DuplicateCheckApplicationViewModel from './screens/custom/duplicatecheckapplicationviewmodel-custom-screen.vue';
import FreshDeskTicketsApplicationViewModel from './screens/custom/freshdeskticketsapplicationviewmodel-custom-screen.vue';
import GlobalConfigurationListModel from './screens/globalconfigurationlistmodel-list-screen.vue';
import Home from './screens/custom/home-custom-screen.vue';
import OrganizationListModel from './screens/organizationlistmodel-deluxelist-screen.vue';
import ProcessedFilesApplicationViewModel from './screens/custom/processedfilesapplicationviewmodel-custom-screen.vue';
import RoleListModel from './screens/rolelistmodel-list-screen.vue';
import SKUMapApplicationViewModel from './screens/custom/skumapapplicationviewmodel-custom-screen.vue';
import TechShipPortalsApplicationViewModel from './screens/custom/techshipportalsapplicationviewmodel-custom-screen.vue';
import ThreePLAuthListModel from './screens/threeplauthlistmodel-list-screen.vue';
import ThreePLLotNumbersApplicationViewModel from './screens/custom/threepllotnumbersapplicationviewmodel-custom-screen.vue';
import ThreePLSerialNumbersApplicationViewModel from './screens/custom/threeplserialnumbersapplicationviewmodel-custom-screen.vue';
import UserListModel from './screens/userlistmodel-list-screen.vue';

import ErrorForbidden from './error-forbidden.vue';
import ErrorNotFound from './error-not-found.vue';

export default [
    { path: '/ApplicationTypes', component: ApplicationTypeListModel },
    { path: '/CanonicalCodes', component: CanonicalCodeListModel },
    { path: '/CarrierApplication/:id/:senderId', component: CarrierApplicationViewModel },
    { path: '/ChargeBeeInvoicesApplication/:id', component: ChargeBeeInvoicesApplicationViewModel },
    { path: '/CrossReferenceApplication/:id/:senderId/:receiverId/:tableName', component: CrossReferenceApplicationViewModel },
    { path: '/CustomerApplications', component: CustomerApplicationListModel },
    { path: '/Customers', component: CustomerListModel },
    { path: '/DuplicateCheckApplication/:id/:senderId/:receiverId', component: DuplicateCheckApplicationViewModel },
    { path: '/FreshDeskTicketsApplication/:id', component: FreshDeskTicketsApplicationViewModel },
    { path: '/GlobalConfiguration', component: GlobalConfigurationListModel },
    { path: '/', component: Home },
    { path: '/Organizations', component: OrganizationListModel },
    { path: '/ProcessedFilesApplication/:id/:senderId/:receiverId/:endPointId', component: ProcessedFilesApplicationViewModel },
    { path: '/Roles', component: RoleListModel },
    { path: '/SKUMapApplication/:id/:senderId/:receiverId', component: SKUMapApplicationViewModel },
    { path: '/TechShipPortalsApplication/:id', component: TechShipPortalsApplicationViewModel },
    { path: '/ThreePLAuthRecords', component: ThreePLAuthListModel },
    { path: '/ThreePLLotNumbersApplication/:id', component: ThreePLLotNumbersApplicationViewModel },
    { path: '/ThreePLSerialNumbersApplication/:id', component: ThreePLSerialNumbersApplicationViewModel },
    { path: '/Users', component: UserListModel },

    { path: '/Forbidden', component: ErrorForbidden },
    { path: '/NotFound', component: ErrorNotFound },
]
